<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-5"></a>
<h1 class="toc_head"><span class="bold">CONTENTS</span></h1>
<h2 class="toc"><a href="#/xhtml/006_Introduction"><em class="italic">Introduction</em></a></h2>
<h2 class="toc"><a href="#/xhtml/007_List_of_Abbreviations"><em class="italic">List of abbreviations</em></a></h2>
<h2 class="toc"><a href="#/xhtml/008_Chapter_1">Images</a></h2>
<h2 class="toc"><span href="#/xhtml/009_Chapter_2" title="Link target outside of Sample">Locomotive details and information</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?9c699e70